<template>
  <span
    class="flex items-center cursor-pointer select-none"
    :class="{ 'w-3.75': !label }"
    v-bind="$attrs"
    @click="toggleSelect"
    v-on="$listeners"
  >
    <OIcon :icon="icon" svg-class="h-3.75 w-3.75" :class="colors" />
    <span v-if="label" class="ml-2.5 text-primary text-sm">{{ label }}</span>
  </span>
</template>

<script>
import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const selected = ref(props.value);
    const toggleSelect = () => {
      selected.value = !selected.value;
      emit('handleSelect', selected.value);
    };

    const icon = computed(() => (selected.value ? 'select-filled' : 'select-stroke'));
    const colors = computed(() => (selected.value ? 'text-o-blue' : 'text-alpha-30'));

    return {
      icon,
      colors,
      selected,
      toggleSelect,
    };
  },
});
</script>

<style></style>
